<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.1683 3.84659V5.99992C14.1683 7.34669 13.7377 7.88412 12.5881 7.99207C12.3132 8.01789 12.0883 7.78939 12.0883 7.51325V6.91992C12.0883 4.83992 11.1616 3.91325 9.08161 3.91325H8.48828C8.21214 3.91325 7.98364 3.68835 8.00946 3.41342C8.11742 2.26386 8.65485 1.83325 10.0016 1.83325H12.1549C13.6816 1.83325 14.1683 2.31992 14.1683 3.84659Z"
    fill="#5B6673"
  />
  <path
    d="M11.0874 6.92V9.08C11.0874 10.6 10.6007 11.0867 9.08073 11.0867H6.92073C5.40073 11.0867 4.91406 10.6 4.91406 9.08V6.92C4.91406 5.4 5.40073 4.91333 6.92073 4.91333H9.08073C10.6007 4.91333 11.0874 5.4 11.0874 6.92Z"
    fill="#5B6673"
  />
  <path
    d="M7.51203 12.0866C7.78817 12.0866 8.01667 12.3115 7.99085 12.5864C7.8829 13.736 7.34547 14.1666 5.9987 14.1666H3.84536C2.3187 14.1666 1.83203 13.6799 1.83203 12.1532V9.99991C1.83203 8.65314 2.26264 8.11571 3.4122 8.00775C3.68713 7.98193 3.91203 8.21043 3.91203 8.48657V9.07991C3.91203 11.1599 4.8387 12.0866 6.9187 12.0866H7.51203Z"
    fill="#5B6673"
  />
</svg>
